{
    "grid-border-color":"#e9e9e9",
    "grid-header-bg-color": "#535c69",
    "grid-header-font-color": "#ffffff",
    "grid-cell-text-align":"left",
    "grid-row-hover-bg-color": "#b8bec7",
    "grid-row-active": "#9ba4b0",
    "grid-row-alternate": "#f1f2f4",
    "grid-footer-bg-color": "#707d8f",
    "grid-footer-font-color": "#ffffff",
    "grid-cell-font-color": "#303030",
    "grid-checkbox-bg-color": "#737373",
    "tile-border-color":"#e9e9e9",
    "tile-bg-color": "#535c69",
    "tile-font-color": "#ffffff",
    "tile-hover-bg-color": "#707d8f",
    "header-bg-color": "#535c69",
    "header-ico-active-color": "#707d8f",
    "title-font-color": "#535c69",
    "login-ico-color": "#535c69",
    "button-primary-bg-color": "#535c69",
    "button-primary-hover-bg-color": "#707d8f",
    "button-secondary-bg-color": "#009999",
    "button-secondary-hover-bg-color": "#009999",
    "button-secondary-font-color": "#ffffff",
    "object-ico-color": "#535c69",
    "object-ico-active-color": "#707d8f"
}